export default __webpack_public_path__ + "static/media/loadingGif.9b769eb8.gif";